export default function Spinner({ size = 'md', label = '' }) {
  const sizeClass = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  }[size]

  return (
    <div className="flex flex-col items-center gap-2">
      <div className={`spinner ${sizeClass}`} />
      {label && <p className="text-label-sm text-text-muted">{label}</p>}
    </div>
  )
}
